import { LeftText, MiddleText, RowBox } from '../styles/common.styles';

const IndoorLocation = ({ indoorLocation }) => {
  if (!indoorLocation) return null;

  return (
    <RowBox data-name="indoor-location">
      <LeftText>Indoor Location:&nbsp;</LeftText>
      <MiddleText data-name="indoor-location-text">{indoorLocation}</MiddleText>
    </RowBox>
  );
};

export default IndoorLocation;
